"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IntlTelInput = _interopRequireDefault(require("./components/IntlTelInput"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = _IntlTelInput.default;
exports.default = _default;